import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { HeadModal } from "./DialogsStyles";
import { PRIMARY_COLOR } from "utils/const";
import { AiFillCloseCircle } from "react-icons/ai";

const OpenDialog = (props) => {
  const { openDialog, setOpenDialog, execute, content } = props;
  const open = openDialog;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <div>
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              maxWidth: "600px", // Set your width here
            },
          },
        }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <HeadModal>
          <div className="title">
            <img
              src="https://icons-greendragon.s3.us-east-2.amazonaws.com/other/d-decimetrix.png"
              alt=""
              className="neurona"
            />
            <span className="titleHeadModal">{content.title}</span>
          </div>
          <Button onClick={handleClose}>
            <AiFillCloseCircle style={{ color: "#FFF", fontSize: 21 }} />
          </Button>
        </HeadModal>
        <DialogTitle sx={{ fontSize: "1.6rem" }} id="responsive-dialog-title">
          {content.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: "1.4rem" }}>
            {content.description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {content.disagree && (
            <Button
              sx={{ fontSize: "1.4rem" }}
              onClick={handleClose}
              style={{
                background: PRIMARY_COLOR,
                borderColor: PRIMARY_COLOR,
                color: "#fff",
              }}
            >
              {content.disagree[0].toUpperCase() + content.disagree.slice(1)}
            </Button>
          )}
          {content.agree && (
            <Button
              sx={{ fontSize: "1.4rem" }}
              onClick={execute}
              autoFocus
              style={{
                background: PRIMARY_COLOR,
                borderColor: PRIMARY_COLOR,
                color: "#fff",
              }}
            >
              {content.agree[0].toUpperCase() + content.agree.slice(1)}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OpenDialog;
